(function() {
  'use strict';

  function money(cents) {
    return (Number(cents || 0) / 100)
      .toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .replace(/[\u00a0\u202f\s]/g, '') + '€';
  }

  function productData() {
    var node = document.querySelector('[data-product-json]');
    if (!node) return { variants: [] };
    try { return JSON.parse(node.textContent || '{"variants":[]}'); }
    catch (error) { return { variants: [] }; }
  }

  function currentVariant(form, data) {
    var select = form.querySelector('[data-variant-select], [data-lite-variant-select], select[name="id"]');
    var id = select ? String(select.value) : '';
    return (data.variants || []).find(function(variant) { return String(variant.id) === id; }) || data.variants[0] || null;
  }

  function addToCartButton(form) {
    return form.querySelector('[data-add-to-cart], [data-lite-atc], button[type="submit"]');
  }

  function variantLabel(variant) {
    var label = variant && String(variant.title || '').trim();
    return !label || label === 'Default Title' ? 'Ce modèle' : label;
  }

  function stockAlertSucceeded() {
    try {
      return new URL(window.location.href).searchParams.get('nh_stock_alert') === 'success';
    } catch (error) {
      return false;
    }
  }

  function moveSharedBlocks() {
    var source = document.querySelector('[data-fw-top30-product-offer-source]');
    if (!source) return;
    var buybox = document.querySelector('.nh-cat__buybox, .nh-pdp__buybox, .nh-lite__buybox');
    if (!buybox) return;

    var kind = buybox.querySelector('.nh-cat__kind');
    if (kind) kind.remove();

    var highlights = source.querySelector('[data-nh-product-highlights]');
    var serverHighlights = buybox.querySelector('[data-nh-product-highlights]');
    var heading = buybox.querySelector('h1');
    if (!buybox.classList.contains('nh-pdp__buybox') && (serverHighlights || highlights) && heading) {
      heading.classList.add('nh-offer-heading');
      if (!serverHighlights && highlights) heading.parentNode.insertBefore(highlights, heading);
    }

    var form = buybox.querySelector('[data-product-form]');
    var bundle = source.querySelector('[data-fw-top30-bundle-selector]');
    if (form && bundle) {
      var atc = form.querySelector('[data-add-to-cart], [data-lite-atc], button[type="submit"]');
      form.insertBefore(bundle, atc || null);
      form.setAttribute('data-fw-top30-bundle-form', 'true');
    }

    var stockAlert = source.querySelector('[data-nh-stock-alert]');
    if (form && stockAlert) {
      form.insertAdjacentElement('afterend', stockAlert);
    }

    var sharedTrust = source.querySelector('[data-nh-shared-trust]');
    var legacyTrust = buybox.querySelector('.nh-lite__trust-row, .nh-pdp__trust-row');
    if (sharedTrust && legacyTrust && !buybox.querySelector('.nh-under-cta-benefits')) {
      legacyTrust.replaceWith(sharedTrust.firstElementChild);
    }
  }

  function normalizeProductOptions() {
    document.querySelectorAll(
      '[data-product-form] .nh-cat__options, ' +
      '[data-product-form] .nh-pdp__options, ' +
      '[data-product-form] .nh-lite__options'
    ).forEach(function(container) {
      container.classList.add('nh-product-options--stacked');

      Array.from(container.children).forEach(function(wrapper) {
        var select = wrapper.querySelector('select:not([name="id"])');
        if (!select) return;

        var title = wrapper.querySelector('.nh-pdp__option-title') || wrapper.querySelector('span');
        var optionName = (title ? title.textContent : select.getAttribute('aria-label') || '')
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        var values = Array.from(select.options)
          .map(function(option) { return String(option.value || '').trim(); })
          .filter(Boolean);
        var uniqueValues = Array.from(new Set(values));

        wrapper.classList.add('nh-product-option');
        if (/taille|size/.test(optionName)) wrapper.classList.add('nh-product-option--size');
        if (/couleur|color/.test(optionName)) {
          wrapper.classList.add('nh-product-option--color');
          if (uniqueValues.length <= 1) {
            wrapper.classList.add('nh-product-option--hidden-single');
            wrapper.setAttribute('aria-hidden', 'true');
          }
        }
      });
    });
  }

  var NH_COLOR_MAP = {
    'noir': '#111318', 'bleu marine': '#1c2a44', 'marine': '#1c2a44', 'bleu': '#2a4f8f',
    'blanc': '#f5f5f5', 'gris clair': '#c4c8cf', 'gris fonce': '#4a4f57', 'gris foncé': '#4a4f57', 'gris': '#8a8f98',
    'rouge': '#b3261e', 'bordeaux': '#6d1f2c', 'vert': '#3c6b4f', 'olive': '#5d6b48', 'kaki': '#6b6b4a',
    'beige': '#d8c8b0', 'marron': '#6b4a35', 'camel': '#b9895a', 'rose': '#d98ca4', 'violet': '#6d4a8f',
    'orange': '#ff6a00', 'jaune': '#e3b93b',
    'camouflage': 'repeating-linear-gradient(45deg,#4c5b3f 0 6px,#2f3a2a 6px 12px,#6b7a55 12px 18px)',
    'camo': 'repeating-linear-gradient(45deg,#4c5b3f 0 6px,#2f3a2a 6px 12px,#6b7a55 12px 18px)'
  };

  function nhSwatchFor(value) {
    var v = (value || '').toLowerCase().trim();
    if (NH_COLOR_MAP[v]) return NH_COLOR_MAP[v];
    var keys = Object.keys(NH_COLOR_MAP);
    for (var i = 0; i < keys.length; i++) {
      if (v.indexOf(keys[i]) !== -1) return NH_COLOR_MAP[keys[i]];
    }
    return '#3a3f47';
  }
  function nhVariantMatrix(form) {
    var vs = form.querySelector('select[name="id"], [data-variant-select], [data-lite-variant-select]');
    if (!vs) return null;
    var rows = [];
    Array.prototype.forEach.call(vs.options, function(o) {
      var t = (o.textContent || '').trim();
      if (!t) return;
      rows.push({ parts: t.split(' / ').map(function(s) { return s.trim(); }), available: !o.disabled });
    });
    return rows.length ? rows : null;
  }

  function nhOptionSelects(form) {
    return Array.prototype.filter.call(form.querySelectorAll('select'), function(s) {
      return !s.closest('[data-fw-top30-bundle-selector]') && !s.matches('[data-variant-select], [data-lite-variant-select], select[name="id"]');
    });
  }

  function nhIsAvailable(matrix, optionSelects, idx, value) {
    if (!matrix) return true;
    return matrix.some(function(row) {
      for (var i = 0; i < optionSelects.length; i++) {
        var want = i === idx ? value : optionSelects[i].value;
        if (row.parts[i] !== undefined && row.parts[i] !== want) return false;
      }
      return row.available;
    });
  }

  function enhanceSizeSelects() {
    document.querySelectorAll('[data-product-form]').forEach(function(form) {
      var matrix = nhVariantMatrix(form);
      var optionSelects = nhOptionSelects(form);
      if (!form.nhOptionRefreshers) form.nhOptionRefreshers = [];

      optionSelects.forEach(function(select, idx) {
        if (select.dataset.nhSizeReady === 'true') return;
        var label = select.closest('label');
        var labelText = label ? (label.querySelector('span') || label).textContent.trim().toLowerCase() : '';
        var isSize = /taille|size|pointure/.test(labelText);
        var isColor = /couleur|coloris|color/.test(labelText);
        if (!isSize && !isColor) return;

        select.dataset.nhSizeReady = 'true';
        select.classList.add('nh-size-select-hidden');
        var group = document.createElement('div');
        group.setAttribute('role', 'group');
        var buttons = [];

        if (isSize) {
          group.className = 'nh-size-pills';
          group.setAttribute('aria-label', 'Choisir la taille');
        } else {
          group.className = 'nh-offer-colors';
          group.setAttribute('aria-label', 'Choisir la couleur');
        }

        Array.prototype.forEach.call(select.options, function(option) {
          var button = document.createElement('button');
          button.type = 'button';
          button.dataset.value = option.value;
          if (isSize) {
            button.className = 'nh-size-pill' + (option.selected ? ' is-selected' : '');
            button.textContent = option.textContent;
          } else {
            button.className = 'nh-offer-color' + (option.selected ? ' is-active' : '');
            var sw = document.createElement('span');
            sw.className = 'nh-offer-color-swatch';
            sw.style.setProperty('--nh-color-swatch', nhSwatchFor(option.value));
            sw.setAttribute('aria-hidden', 'true');
            var lbl = document.createElement('span');
            lbl.textContent = option.textContent;
            button.appendChild(sw);
            button.appendChild(lbl);
          }
          button.disabled = option.disabled;
          button.setAttribute('aria-pressed', option.selected ? 'true' : 'false');
          button.addEventListener('click', function() {
            if (button.disabled) return;
            select.value = button.dataset.value;
            buttons.forEach(function(item) {
              var selected = item === button;
              item.classList.toggle(isSize ? 'is-selected' : 'is-active', selected);
              item.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
          buttons.push(button);
          group.appendChild(button);
        });
        select.insertAdjacentElement('afterend', group);
        var refresh = function() {
          buttons.forEach(function(b) {
            b.disabled = !nhIsAvailable(matrix, optionSelects, idx, b.dataset.value);
            var selected = b.dataset.value === select.value;
            b.classList.toggle(isSize ? 'is-selected' : 'is-active', selected);
            b.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        };
        form.nhOptionRefreshers.push(refresh);
        refresh();
      });

      if (!form.dataset.nhOptListen && form.nhOptionRefreshers.length) {
        form.dataset.nhOptListen = '1';
        form.addEventListener('change', function() {
          form.nhOptionRefreshers.forEach(function(r) { r(); });
        });
      }
    });
  }

  function alignSizeGuides() {
    document.querySelectorAll('[data-product-form]').forEach(function(form) {
      var guide = form.querySelector('.nh-size-guide');
      var sizeOption = form.querySelector('.nh-product-option--size');
      if (!guide || !sizeOption || guide.dataset.nhAligned === 'true') return;

      var title = sizeOption.querySelector('.nh-pdp__option-title') || sizeOption.querySelector(':scope > span');
      if (!title || !sizeOption.parentNode) return;

      var titleText = title.textContent.trim();
      var select = sizeOption.querySelector('select');
      if (select && titleText && !select.getAttribute('aria-label')) {
        select.setAttribute('aria-label', titleText);
      }

      var head = document.createElement('div');
      head.className = 'nh-size-option-head';

      sizeOption.parentNode.insertBefore(head, sizeOption);
      title.classList.remove('nh-option-title--source-hidden');
      title.classList.add('nh-size-option-title');
      head.appendChild(title);
      head.appendChild(guide);
      guide.dataset.nhAligned = 'true';
    });
  }

  function bundleQuantity(form) {
    var selected = form.querySelector('input[name="nh_bundle_tier"]:checked');
    return Number(selected && selected.dataset.bundleQuantity) || 1;
  }

  function optionKey(name) {
    return String(name || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  function optionNames(product) {
    return product.options.map(function(option) { return option.name || option; });
  }

  function bundleElement(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function slotVariants(state, slot) {
    var source = state.sources[slot.source];
    if (!source || !source.product) return [];
    var colorIndex = optionNames(source.product).findIndex(function(name) { return /couleur|color/.test(optionKey(name)); });
    return source.product.variants.filter(function(variant) {
      return !state.linked || colorIndex < 0 || optionKey(variant.options[colorIndex]) === optionKey(source.label);
    });
  }

  function slotVariant(state, slot) {
    return slotVariants(state, slot).find(function(variant) {
      return variant.options.every(function(value, index) { return value === slot.values[index]; });
    });
  }

  function selectedGarments(form, estimate) {
    var quantity = bundleQuantity(form);
    var fallback = currentVariant(form, productData());
    var state = form.nhBundleOptions;
    if (quantity === 1 || !state) return Array(quantity).fill(fallback);
    return state.slots.slice(0, quantity).map(function(slot) {
      return slotVariant(state, slot) || (estimate && (slotVariants(state, slot).find(function(v) { return v.available; }) || fallback));
    });
  }

  function loadBundleSource(form, source) {
    if (source.product || source.loading) return;
    source.loading = true;
    source.error = false;
    var url = new URL(source.url, window.location.origin);
    fetch(url.pathname.replace(/\/$/, '') + '.js', { headers: { Accept: 'application/json' } })
      .then(function(response) {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      }).then(function(product) {
        if (!Array.isArray(product.variants) || !product.variants.length) throw new Error('Missing variants');
        source.product = product;
      }).catch(function() { source.error = true; }).finally(function() {
        source.loading = false;
        if (bundleQuantity(form) > 1) renderBundleOptions(form);
      });
  }

  function initBundleOptions(form, bundle) {
    var dataNode = bundle.querySelector('[data-fw-top30-bundle-product]');
    if (!dataNode) return;
    var product;
    try { product = JSON.parse(dataNode.textContent); } catch (error) { return; }
    if (!product.variants || !product.variants.length) return;
    var links = Array.from(form.querySelectorAll('.nh-cat__linked-color, .nh-pdp__color-swatches a'));
    var state = { slots: [], sources: [], linked: links.length > 1, product: product, active: false };
    if (state.linked) {
      links.forEach(function(link) {
        var url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin || !/\/products\/[^/]+$/.test(url.pathname)) return;
        var current = url.pathname.split('/').pop() === product.handle;
        var img = link.querySelector('img');
        state.sources.push({ url: url.pathname, label: link.textContent.trim(), image: img && img.src, product: current ? product : null });
        if (current) state.currentSource = state.sources.length - 1;
      });
    }
    if (state.currentSource === undefined) {
      state.sources = [{ product: product, label: '', url: '/products/' + product.handle }];
      state.linked = false;
      state.currentSource = 0;
    }
    var editor = bundleElement('div', 'nh-bundle-options');
    editor.dataset.nhBundleOptions = '';
    editor.hidden = true;
    var rows = bundleElement('div', 'nh-bundle-options__rows');
    editor.appendChild(rows);
    var error = bundleElement('p', 'nh-bundle-options__error');
    error.id = 'NhBundleError-' + product.id;
    error.setAttribute('role', 'alert');
    error.hidden = true;
    editor.appendChild(error);
    Object.assign(state, { editor: editor, rows: rows, error: error });
    state.soloOptions = Array.from(form.querySelectorAll('.nh-cat__options, .nh-pdp__options, .nh-lite__options, .nh-pdp__color-switch, .nh-cat__linked-colors')).map(function(node) {
      return { node: node, display: node.style.getPropertyValue('display'), priority: node.style.getPropertyPriority('display') };
    });
    state.guide = form.querySelector('.nh-size-guide');
    if (state.guide) {
      state.guideOrigin = document.createComment('bundle size guide return');
      state.guide.before(state.guideOrigin);
    }
    form.nhBundleOptions = state;
    bundle.appendChild(editor);
  }

  function renderBundleOptions(form) {
    var state = form.nhBundleOptions;
    if (!state) return;
    var quantity = bundleQuantity(form);
    var active = quantity > 1;
    if (!active && state.active) {
      var first = state.slots[0];
      var firstVariant = slotVariant(state, first);
      if (firstVariant && firstVariant.available && first.source === state.currentSource) {
        nhOptionSelects(form).forEach(function(select, index) {
          var position = select.dataset.optionIndex ? Number(select.dataset.optionIndex) - 1 : index;
          var value = firstVariant.options[position];
          if (Array.from(select.options).some(function(option) { return option.value === value; })) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        var variantSelect = form.querySelector('select[name="id"]');
        if (variantSelect) {
          variantSelect.value = String(firstVariant.id);
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    if (active && !state.active) {
      var current = currentVariant(form, productData());
      var variant = state.product.variants.find(function(item) { return String(item.id) === String(current.id); }) || state.product.variants[0];
      if (!state.slots.length || state.soloChanged) {
        state.slots[0] = { source: state.currentSource, values: variant.options.slice() };
        state.soloChanged = false;
      }
    }
    state.active = active;
    form.classList.toggle('nh-bundle-form--multiple', active);
    state.editor.hidden = !active;
    if (state.guide && !active && state.guide.previousSibling !== state.guideOrigin) {
      state.guideOrigin.after(state.guide);
    }
    state.soloOptions.forEach(function(option) {
      if (active) option.node.style.setProperty('display', 'none', 'important');
      else if (option.display) option.node.style.setProperty('display', option.display, option.priority);
      else option.node.style.removeProperty('display');
    });
    state.error.hidden = true;
    if (!active) {
      state.editor.querySelectorAll('select').forEach(function(select) { select.disabled = true; });
      return;
    }
    var bundle = form.querySelector('[data-fw-top30-bundle-selector]');
    var selected = bundle.querySelector('input[name="nh_bundle_tier"]:checked');
    var unlock = selected.closest('.nh-bundle__option').querySelector('.nh-bundle__unlock');
    if (state.editor.previousElementSibling !== unlock) unlock.after(state.editor);
    while (state.slots.length < 3) {
      var initial = state.slots[0];
      state.slots.push({ source: initial.source, values: initial.values.map(function(value, index) {
        return /taille|size/.test(optionKey(optionNames(state.product)[index])) ? '' : value;
      }) });
    }
    while (state.rows.children.length > quantity) state.rows.lastElementChild.remove();
    state.slots.slice(0, quantity).forEach(function(slot, index) {
      var source = state.sources[slot.source];
      var product = source.product;
      var candidates = slotVariants(state, slot);
      var row = state.rows.children[index];
      if (!row) {
        row = bundleElement('fieldset', 'nh-bundle-options__row');
        row.appendChild(bundleElement('legend', 'nh-bundle-options__sr-only', bundle.dataset.productLabel + ' ' + (index + 1)));
        var head = bundleElement('div', 'nh-bundle-options__row-head');
        var label = bundleElement('span', 'nh-bundle-options__label', bundle.dataset.productLabel.replace(/ chauffante?$/, '') + ' ' + (index + 1));
        label.setAttribute('aria-hidden', 'true');
        head.appendChild(label);
        row.appendChild(head);
        var content = bundleElement('div', 'nh-bundle-options__row-content');
        content.appendChild(bundleElement('div', 'nh-bundle-options__fields'));
        row.appendChild(content);
        state.rows.appendChild(row);
      }
      var rowHead = row.querySelector('.nh-bundle-options__row-head');
      if (index === 0 && state.guide && state.guide.parentNode !== rowHead) rowHead.appendChild(state.guide);
      var fields = row.querySelector('.nh-bundle-options__fields');
      var usedFields = [];
      function addSelect(key, name, value, values, change) {
        var label = Array.from(fields.children).find(function(node) { return node.dataset.nhBundleOption === key; });
        if (!label) {
          label = bundleElement('label', 'nh-bundle-options__field');
          label.dataset.nhBundleOption = key;
          label.appendChild(bundleElement('span', 'nh-bundle-options__sr-only', name));
          var control = document.createElement('select');
          control.dataset.nhBundleField = String(index);
          control.setAttribute('aria-label', name + ' du vêtement ' + (index + 1));
          control.setAttribute('aria-required', 'true');
          control.addEventListener('change', function(event) {
            event.stopPropagation();
            control.nhBundleChange(control.value);
            renderBundleOptions(form);
          });
          label.appendChild(control);
          var chevron = bundle.querySelector('.nh-bundle__chevron svg');
          if (chevron) {
            chevron = chevron.cloneNode(true);
            chevron.setAttribute('class', 'nh-bundle-options__chevron');
            chevron.setAttribute('aria-hidden', 'true');
            label.appendChild(chevron);
          }
          fields.appendChild(label);
        }
        usedFields.push(label);
        label.hidden = false;
        label.classList.toggle('nh-bundle-options__field--size', /taille|size/.test(optionKey(name)));
        var select = label.querySelector('select');
        select.disabled = false;
        select.nhBundleChange = change;
        select.removeAttribute('aria-invalid');
        select.removeAttribute('aria-describedby');
        values.forEach(function(entry, position) {
          var option = Array.from(select.options).find(function(item) { return item.value === String(entry.value); });
          if (!option) option = new Option(entry.label, entry.value);
          if (option.textContent !== entry.label) option.textContent = entry.label;
          if (option.disabled !== Boolean(entry.disabled)) option.disabled = Boolean(entry.disabled);
          if (select.options[position] !== option) select.insertBefore(option, select.options[position] || null);
        });
        Array.from(select.options).forEach(function(option) {
          if (!values.some(function(entry) { return String(entry.value) === option.value; })) option.remove();
        });
        if (select.value !== value) select.value = value;
        var color = /couleur|color/.test(optionKey(name)) && value !== '';
        label.classList.toggle('nh-bundle-options__field--color', color);
        var swatch = label.querySelector('.nh-bundle-options__color');
        if (color) {
          if (!swatch) {
            swatch = bundleElement('span', 'nh-bundle-options__color');
            swatch.setAttribute('aria-hidden', 'true');
            label.appendChild(swatch);
          }
          swatch.hidden = false;
          swatch.style.background = nhSwatchFor(select.selectedOptions[0]?.textContent || value);
        } else if (swatch) swatch.hidden = true;
      }
      if (state.linked) {
        addSelect('linked-color', 'Couleur', String(slot.source), state.sources.map(function(entry, i) {
          return { label: entry.label, value: String(i) };
        }), function(value) {
          slot.source = Number(value);
          var names = optionNames(state.product);
          names.forEach(function(name, i) {
            if (/couleur|color/.test(optionKey(name))) slot.values[i] = state.sources[slot.source].label;
          });
        });
      }
      if (product) {
        var options = optionNames(product).map(function(name, optionIndex) { return { name: name, index: optionIndex }; });
        options.sort(function(a, b) { return Number(/couleur|color/.test(optionKey(b.name))) - Number(/couleur|color/.test(optionKey(a.name))); });
        options.forEach(function(option) {
          var name = option.name;
          var optionIndex = option.index;
          var color = /couleur|color/.test(optionKey(name));
          var values = Array.from(new Set(candidates.map(function(v) { return v.options[optionIndex]; })));
          if (state.linked && color) {
            slot.values[optionIndex] = values[0];
            return;
          }
          if (values.length === 1 && !/taille|size/.test(optionKey(name))) {
            slot.values[optionIndex] = values[0];
            return;
          }
          var entries = [{ label: /taille|size/.test(optionKey(name)) ? 'Taille' : name, value: '' }];
          values.forEach(function(value) {
            var available = candidates.some(function(v) {
              return v.available && v.options[optionIndex] === value && v.options.every(function(other, i) {
                return i === optionIndex || color || !slot.values[i] || other === slot.values[i];
              });
            });
            var displayLabel = value;
            if (product.id === state.product.id) {
              var sourceSelect = form.querySelector('select[data-option-index="' + (optionIndex + 1) + '"]');
              var sourceOption = sourceSelect && Array.from(sourceSelect.options).find(function(item) { return item.value === value; });
              if (sourceOption && sourceOption.dataset.bundleLabel) displayLabel = sourceOption.dataset.bundleLabel;
            }
            entries.push({ label: displayLabel + (available ? '' : ' · Épuisé'), value: value, disabled: !available });
          });
          addSelect('option-' + optionKey(name), name, slot.values[optionIndex] || '', entries, function(value) {
            slot.values[optionIndex] = value;
            if (color && !slotVariant(state, slot)?.available) {
              optionNames(product).forEach(function(otherName, i) {
                if (/taille|size/.test(optionKey(otherName))) slot.values[i] = '';
              });
            }
          });
        });
      } else {
        var message = fields.querySelector('.nh-bundle-options__loading');
        if (!message) {
          message = bundleElement('span', 'nh-bundle-options__loading');
          fields.appendChild(message);
        }
        message.textContent = source.error ? 'Tailles indisponibles pour le moment.' : 'Chargement des tailles…';
        message.hidden = false;
        usedFields.push(message);
        if (source.error) {
          var retry = fields.querySelector('.nh-bundle-options__retry');
          if (!retry) {
            retry = bundleElement('button', 'nh-bundle-options__retry', 'Réessayer');
            retry.type = 'button';
            fields.appendChild(retry);
          }
          retry.hidden = false;
          retry.onclick = function() { loadBundleSource(form, source); renderBundleOptions(form); };
          usedFields.push(retry);
        } else loadBundleSource(form, source);
      }
      Array.from(fields.children).forEach(function(node) {
        if (usedFields.indexOf(node) >= 0) return;
        node.hidden = true;
        var select = node.querySelector('select');
        if (select) select.disabled = true;
      });
      row.classList.toggle('nh-bundle-options__row--multiple-fields', usedFields.length > 1);
    });
    updateOfferPrices(form);
  }

  function validateBundleOptions(form) {
    var state = form.nhBundleOptions;
    if (!state || bundleQuantity(form) === 1) return true;
    var invalid = selectedGarments(form, false).findIndex(function(v) { return !v || !v.available; });
    if (invalid < 0) return true;
    state.error.textContent = 'Choisissez une taille disponible pour le vêtement ' + (invalid + 1) + '.';
    state.error.hidden = false;
    var fields = Array.from(state.rows.children[invalid].querySelectorAll('select')).filter(function(select) { return !select.disabled && !select.closest('[hidden]'); });
    var field = fields.find(function(select) { return !select.value || select.selectedOptions[0]?.disabled; }) || fields[fields.length - 1];
    if (field) {
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', state.error.id);
      field.focus();
    }
    return false;
  }

  function updateOfferPrices(form) {
    var data = productData();
    var variant = currentVariant(form, data);
    if (!variant) return;
    var bundle = form.querySelector('[data-fw-top30-bundle-selector]');
    var selected = bundle ? bundle.querySelector('input[name="nh_bundle_tier"]:checked') : null;
    var quantity = selected ? Number(selected.dataset.bundleQuantity || 1) : 1;
    var unitPrice = Number(variant.price || 0);
    var unitCompare = Number(variant.compare_at_price || 0);
    var bundlePct = selected ? Number(selected.dataset.bundleDiscount || 0) : 0;
    var garments = selectedGarments(form, true);
    var fullPrice = garments.reduce(function(total, item) { return total + Number(item.price || 0); }, 0);
    var totalPrice = garments.reduce(function(total, item) {
      return total + Math.round(Number(item.price || 0) * (100 - bundlePct) / 100);
    }, 0);
    var totalCompare = garments.reduce(function(total, item) { return total + Math.max(Number(item.price || 0), Number(item.compare_at_price || 0)); }, 0);
    var hasSaving = totalCompare > totalPrice;
    var saving = hasSaving ? totalCompare - totalPrice : 0;

    if (bundle) {
      bundle.querySelectorAll('[data-bundle-price]').forEach(function(node) {
        var qty = Number(node.dataset.bundlePrice || 1);
        var pct = Number(node.dataset.bundleDiscount || 0);
        var full = unitPrice * qty;
        var ref = (unitCompare > unitPrice ? unitCompare : unitPrice) * qty; 
        var paye = Math.round(unitPrice * (100 - pct) / 100) * qty;
        if (qty === quantity) { paye = totalPrice; ref = totalCompare; }
        if (ref > paye) {
          node.innerHTML = '<b>' + money(paye) + '</b> <s>' + money(ref) + '</s>';
        } else {
          node.textContent = money(paye);
        }
      });
    }

    var buybox = form.closest('.nh-cat__buybox, .nh-pdp__buybox, .nh-lite__buybox');
    if (buybox) {
      var currentPrice = buybox.querySelector('.nh-cat__current, .nh-pdp__current, .nh-lite__current');
      var comparePrice = buybox.querySelector('.nh-cat__compare, .nh-pdp__compare, .nh-lite__compare');
      var savingPrice = buybox.querySelector('.nh-cat__saving, .nh-pdp__saving, .nh-lite__saving');

      if (currentPrice) currentPrice.textContent = money(totalPrice);
      if (comparePrice) {
        comparePrice.textContent = hasSaving ? money(totalCompare) : '';
        comparePrice.hidden = !hasSaving;
      }
      if (savingPrice) {
        savingPrice.textContent = hasSaving ? 'Vous économisez ' + money(saving) : '';
        savingPrice.hidden = !hasSaving;
      }
    }

    var atcPrice = form.querySelector('[data-atc-price]');
    var atcCompare = form.querySelector('[data-atc-compare]');
    if (atcPrice) atcPrice.textContent = money(totalPrice);
    if (atcCompare) {
      atcCompare.textContent = hasSaving ? money(totalCompare) : '';
      atcCompare.hidden = !hasSaving;
    }

    syncAvailability(form, variant);
  }

  function updateStockAlert(form, variant) {
    var buybox = form.closest('.nh-cat__buybox, .nh-pdp__buybox, .nh-lite__buybox');
    var alert = buybox && buybox.querySelector('[data-nh-stock-alert]');
    if (!alert) return;

    var available = Boolean(variant && variant.available);
    var succeeded = stockAlertSucceeded();
    var label = variantLabel(variant);
    var variantId = variant ? String(variant.id) : '';
    var handle = alert.dataset.productHandle || '';
    var capture = alert.querySelector('[data-nh-stock-capture]');
    var success = alert.querySelector('[data-nh-stock-success]');
    var tags = alert.querySelector('[data-nh-stock-tags]');
    var returnTo = alert.querySelector('[data-nh-stock-return]');

    alert.querySelectorAll('[data-nh-stock-variant-label], [data-nh-stock-success-variant]').forEach(function(node) {
      node.textContent = label;
    });
    if (tags) {
      tags.value = ['newsletter', '9heat-stock-alert', 'stock-product-' + handle, 'stock-variant-' + variantId].join(',');
    }
    if (returnTo) {
      returnTo.value = window.location.pathname + '?variant=' + encodeURIComponent(variantId) + '&nh_stock_alert=success#' + alert.id;
    }

    alert.hidden = available && !succeeded;
    if (capture) capture.hidden = succeeded;
    if (success) success.hidden = !succeeded;
  }

  function syncAvailability(form, variant) {
    var data = productData();
    variant = variant || currentVariant(form, data);
    if (!variant) return;

    var available = Boolean(variant.available);
    var bundle = form.querySelector('[data-fw-top30-bundle-selector]');
    var button = addToCartButton(form);
    var multiple = Boolean(form.nhBundleOptions && bundleQuantity(form) > 1);
    if (multiple) available = true;

    if (bundle) {
      bundle.classList.toggle('is-sold-out', !available);
      bundle.setAttribute('aria-disabled', available ? 'false' : 'true');
      bundle.querySelectorAll('input[name="nh_bundle_tier"]').forEach(function(input) {
        input.disabled = !available && !form.nhBundleOptions;
      });
      var stockState = bundle.querySelector('[data-fw-top30-bundle-stock-state]');
      var intro = bundle.querySelector('[data-fw-top30-bundle-intro]');
      if (stockState) stockState.hidden = available;
      if (intro) intro.hidden = !available;
    }

    if (button) {
      var text = button.querySelector('.atc-text, [data-atc-text]');
      button.classList.toggle('nh-atc--sold-out', !available);
      button.disabled = !available || form.dataset.nhSubmitting === 'true';
      button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
      if (text && form.dataset.nhSubmitting !== 'true') text.textContent = available ? 'Ajouter au panier' : 'Rupture de stock';
    }

    updateStockAlert(form, variant);
    if (multiple) {
      var alert = form.closest('.nh-cat__buybox, .nh-pdp__buybox, .nh-lite__buybox')?.querySelector('[data-nh-stock-alert]');
      if (alert) alert.hidden = true;
    }
    document.dispatchEvent(new CustomEvent('nh:stock-alert-state', {
      detail: { active: !available }
    }));
  }

  function syncBundleState(bundle) {
    var selected = bundle.querySelector('input[name="nh_bundle_tier"]:checked');
    bundle.querySelectorAll('.nh-bundle__option').forEach(function(option) {
      option.classList.toggle('is-selected', Boolean(option.querySelector('input[name="nh_bundle_tier"]:checked')));
    });
    var intro = bundle.querySelector('[data-fw-top30-bundle-intro]');
    if (intro && selected && selected.dataset.bundleRewardCopy) {
      intro.textContent = selected.dataset.bundleRewardCopy;
    }
  }

  function initBundles() {
    document.querySelectorAll('[data-fw-top30-bundle-form]').forEach(function(form) {
      var bundle = form.querySelector('[data-fw-top30-bundle-selector]');
      if (!bundle) return;
      initBundleOptions(form, bundle);
      bundle.addEventListener('click', function(event) {
        if (event.target.closest('label, input, select, button, a, [data-fw-top30-bundle-options]')) return;
        var option = event.target.closest('.nh-bundle__option');
        var radio = option && option.querySelector('input[name="nh_bundle_tier"]');
        if (radio && !radio.checked && !radio.disabled) radio.click();
      });
      bundle.querySelectorAll('input[name="nh_bundle_tier"]').forEach(function(input) {
        input.addEventListener('change', function() {
          syncBundleState(bundle);
          renderBundleOptions(form);
          updateOfferPrices(form);
        });
      });
      form.addEventListener('change', function(event) {
        if (form.nhBundleOptions && !event.target.closest('[data-fw-top30-bundle-selector]')) form.nhBundleOptions.soloChanged = true;
        window.setTimeout(function() { updateOfferPrices(form); }, 0);
      });
      syncBundleState(bundle);
      renderBundleOptions(form);
      updateOfferPrices(form);
    });
  }

  function initAvailability() {
    document.querySelectorAll('[data-product-form]').forEach(function(form) {
      var refresh = function() {
        window.setTimeout(function() { syncAvailability(form); }, 0);
        window.setTimeout(function() { syncAvailability(form); }, 80);
      };
      form.addEventListener('change', refresh);
      syncAvailability(form);
    });

    document.addEventListener('variant:change', function(event) {
      var form = event.target && event.target.closest ? event.target.closest('[data-product-form]') : null;
      if (form) syncAvailability(form);
    });
  }

  function giftItem(id, quantity, bundleId, label, minimum, perGarment) {
    return {
      id: Number(id),
      quantity: Number(quantity),
      properties: {
        '_nh_gift': 'true',
        '_nh_bundle_id': bundleId,
        '_nh_gift_label': label,
        '_nh_gift_minimum': String(minimum || 1),
        '_nh_gift_per_garment': perGarment === false ? 'false' : 'true'
      }
    };
  }

  async function submitBundle(form) {
    var data = productData();
    var variant = currentVariant(form, data);
    var bundle = form.querySelector('[data-fw-top30-bundle-selector]');
    var selected = bundle && bundle.querySelector('input[name="nh_bundle_tier"]:checked');
    if (!variant || !selected) throw new Error('Sélectionnez une taille et un pack.');
    if (!validateBundleOptions(form)) throw new Error('Choisissez les tailles de votre pack.');
    var garments = selectedGarments(form, false);
    if (garments.some(function(item) { return !item || !item.available; })) throw new Error('Cette variante est épuisée.');

    var quantity = Number(selected.dataset.bundleQuantity || 1);
    var tier = String(selected.value || quantity);
    var bundleId = 'nh-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    var items = [];
    garments.forEach(function(garment) {
      var existing = items.find(function(item) { return item.id === Number(garment.id); });
      if (existing) existing.quantity += 1;
      else items.push({ id: Number(garment.id), quantity: 1,
        properties: { '_nh_bundle_id': bundleId, '_nh_bundle_tier': tier, '_nh_bundle_version': '2' } });
    });
    items.push(giftItem(bundle.dataset.batteryVariant, quantity, bundleId, quantity + ' batterie' + (quantity > 1 ? 's' : '') + ' offerte' + (quantity > 1 ? 's' : '')));
    if (quantity >= 2) items.push(giftItem(bundle.dataset.beanieVariant, quantity, bundleId, quantity + ' bonnets offerts', 2));
    items.push(giftItem(bundle.dataset.washVariant, quantity, bundleId, quantity + ' filet' + (quantity > 1 ? 's' : '') + ' de lavage offert' + (quantity > 1 ? 's' : '')));
    items.push(giftItem(bundle.dataset.caseVariant, quantity, bundleId, quantity + ' trousse' + (quantity > 1 ? 's' : '') + ' de rangement offerte' + (quantity > 1 ? 's' : '')));
    if (quantity >= 3) {
      items.push(giftItem(bundle.dataset.handwarmerVariant, 1, bundleId, 'Chauffe-mains offert', 3, false));
    }

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    var payload = await response.json();
    if (!response.ok) throw new Error(payload.description || 'Impossible d’ajouter ce pack au panier.');
    return payload;
  }

  function publishBundleAdded(resource, form, quantity) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: resource || null,
        sourceId: form.id || '9heat-bundle-form',
        data: {
          source: '9heat-bundle-form',
          action: 'add',
          openDrawer: true,
          itemCount: quantity
        }
      }
    }));
  }

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('[data-fw-top30-bundle-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    if (form.dataset.nhSubmitting === 'true') return;

    var button = addToCartButton(form);
    if (!button || button.disabled) return;
    if (!validateBundleOptions(form)) return;
    var selected = form.querySelector('[data-fw-top30-bundle-selector] input[name="nh_bundle_tier"]:checked');
    var quantity = Number(selected && selected.dataset.bundleQuantity) || 1;
    var original = button.innerHTML;
    var text = button.querySelector('.atc-text') || button.querySelector('span');
    form.dataset.nhSubmitting = 'true';
    button.disabled = true;
    if (text) text.textContent = 'Ajout du pack…';

    submitBundle(form).then(function(resource) {
      publishBundleAdded(resource, form, quantity);
    }).catch(function(error) {
      window.alert(error.message || 'Impossible d’ajouter ce pack au panier.');
    }).finally(function() {
      delete form.dataset.nhSubmitting;
      button.innerHTML = original;
      updateOfferPrices(form);
    });
  }, true);
  function warmGalleries() {
    var warmed = {};
    function preload(url, sizes, srcset) {
      if (!url || warmed[url]) return;
      warmed[url] = true;
      var im = new Image();
      if (srcset) { im.sizes = sizes || '100vw'; im.srcset = srcset; }
      im.src = url;
    }
    function collect() {
      var out = [];
      document.querySelectorAll('[data-lite-thumb]').forEach(function(b) {
        out.push({ url: b.getAttribute('data-lite-src'), srcset: b.getAttribute('data-lite-srcset'),
                   sizes: (document.querySelector('[data-lite-main]') || {}).sizes });
      });
      document.querySelectorAll('.nh-cat__track img[loading="lazy"], .nh-cat__track img[data-gallery-src]').forEach(function(img) {
        out.push({ url: img.getAttribute('data-gallery-src') || img.currentSrc || img.src,
                   srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') });
      });
      return out;
    }
    function warm(n) {
      var list = collect();
      for (var i = 0; i < list.length && (n < 0 || i < n); i++) preload(list[i].url, list[i].sizes, list[i].srcset);
    }
    var full = false;
    function warmAll() {
      if (full) return;
      full = true;
      warm(-1);
    }
    var idle = function() {
      if ('requestIdleCallback' in window) requestIdleCallback(function() { warm(3); }, { timeout: 5000 });
      else setTimeout(function() { warm(3); }, 2000);
    };
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
    ['pointerenter', 'touchstart', 'click'].forEach(function(ev) {
      document.querySelectorAll('.nh-cat__gallery, .nh-lite__gallery, [data-lite-thumb], [data-gallery-next], [data-gallery-prev]').forEach(function(el) {
        el.addEventListener(ev, warmAll, { once: true, passive: true });
      });
    });
  }
  function alignHeroSplit() {
    var heros = document.querySelectorAll('.nh-cat__hero, .nh-lite__hero, .nh-pdp__hero');
    if (!heros.length) return;

    function place() {
      heros.forEach(function(hero) {
        var media = hero.querySelector('.nh-cat__gallery, .nh-lite__gallery, .nh-pdp__gallery');
        if (!media) return;
        var bas = media.getBoundingClientRect().bottom - hero.getBoundingClientRect().top;
        var hauteur = hero.offsetHeight;
        if (!hauteur || bas <= 0) return;
        var split = Math.min(Math.max(bas + 14, hauteur * 0.2), hauteur - 1);
        hero.style.setProperty('--nh-hero-split', Math.round(split) + 'px');
      });
    }

    place();
    window.addEventListener('load', place);
    window.addEventListener('resize', function() {
      clearTimeout(place._t);
      place._t = setTimeout(place, 120);
    });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(place);
      heros.forEach(function(hero) {
        var media = hero.querySelector('.nh-cat__gallery, .nh-lite__gallery, .nh-pdp__gallery');
        if (media) ro.observe(media);
      });
    }
  }

  function init() {
    moveSharedBlocks();
    initBundles();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
